<form class="ui form" #form="ngForm">
    <app-segment-header title="Basic Information"></app-segment-header>
    <div class="app-grid">
        <div class="columns-3 field">
            <label class="font-medium">First name</label>
            <div>{{ applicant?.firstName || 'none' }}</div>
        </div>
        <div class="columns-3 field">
            <label class="font-medium">Last name</label>
            <div>{{ applicant?.lastName || 'none' }}</div>
        </div>
    </div>

    <div class="app-grid">
        <div class="columns-3 field">
            <label class="font-medium">Email</label>
            <div>{{ applicant?.email || 'none' }}</div>
        </div>
        <div class="columns-3 field">
            <label class="font-medium">Phone</label>
            <div>{{ applicant?.phone || 'none' }}</div>
        </div>
    </div>

    <div class="app-grid">
        <div class="columns-3 field">
            <label class="font-medium">Country</label>
            <div>{{ applicant?.country || 'none' }}</div>
        </div>
        <div class="columns-3 field">
            <label class="font-medium">Postal code</label>
            <div>{{ applicant?.postalCode || 'none' }}</div>
        </div>
    </div>

    <div class="app-grid">
        <div class="columns-3 field">
            <label class="font-medium">Job posting</label>
            <div>{{ applicant?.jobPosting?.title || 'none' }}</div>
        </div>
    </div>
</form>
